/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Value_MinutesInputs */

const en_us2_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const pt_br2_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const es_419_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const pt_pt2_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const fr_fr2_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const de_de2_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

const it_it2_search_value_minutes = /** @type {(inputs: Search_Value_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min`)
};

/**
* | output |
* | --- |
* | "{count} min" |
*
* @param {Search_Value_MinutesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_value_minutes = /** @type {((inputs: Search_Value_MinutesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Value_MinutesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_value_minutes(inputs)
	if (locale === "es-419") return es_419_search_value_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_search_value_minutes(inputs)
	if (locale === "fr-FR") return fr_fr2_search_value_minutes(inputs)
	if (locale === "de-DE") return de_de2_search_value_minutes(inputs)
	if (locale === "it-IT") return it_it2_search_value_minutes(inputs)
	return en_us2_search_value_minutes(inputs)
});
export { search_value_minutes as "search.value_minutes" }